/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export const AUSWERTUNG_BELEGE_ID = "a1f6471c-2987-45fd-8d97-bedd0022eae4" as const;
export const AUSWERTUNG_SEMINARRESSOURCENBELEGUNGEN_ID = "60c58f1d-eff0-4d12-bf5a-6d3152c0b20e" as const;
export const AUSWERTUNG_FRAGEBOGEN_ID = "3f58d56c-4fab-4f19-b614-976206841ac4" as const;

export default class AuswertungenConstants {
    public static auswertungBelegeId = AUSWERTUNG_BELEGE_ID;
    public static auswertungSeminarRessourcenBelegungenId = AUSWERTUNG_SEMINARRESSOURCENBELEGUNGEN_ID;
    public static auswertungFragebogenId = AUSWERTUNG_FRAGEBOGEN_ID;
}
